/* import __COLOCATED_TEMPLATE__ from './merged.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './merged.module.scss';

@classic
@classNames(styles.component)
export default class SignInTokenStatesMerged extends Component {}
